// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("app/partials/lead.status.select.box.html?raw");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<selectbox ng-show=\"vm.statuses && vm.statuses.length > 1\" ng-model=\"vm.statusId\" ng-options=\"vm.statuses\" ng-change=\"vm.leadStatusChange(vm.statusId)\" template-url=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"> </selectbox> ";
// Exports
module.exports = code;